<template>
  <div class="systemMain">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="queryData">
          <el-input
            style="width: 150px"
            placeholder="角色名称"
            @keyup.enter.native="getDataList(true)"
            clearable
            v-model.trim="queryData.name"
          >
            <!-- v-model="queryData.like[0][2]" -->
          </el-input>
          <el-button type="success" @click="getDataList">查询</el-button>
          <el-button type="primary" @click="addOrEditPopup(0)"
            >新增角色</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        row-key="roleId"
        v-loading="loadingFlag"
        element-loading-text="正在拼命加载中"
        element-loading-spinner="el-icon-loading"
        ><el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="roleName" label="角色名称" min-width="180">
        </el-table-column
        ><el-table-column prop="roleId" label="角色id" min-width="180">
        </el-table-column>
        <el-table-column prop="indexUrl" label="入口页" min-width="180">
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180">
        </el-table-column>
        <el-table-column prop="sort" label="排序" min-width="180">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="180"
          ><template slot-scope="scope">
            <div>{{ VueDateFormat(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="addOrEditPopup(scope.row)"
              >编辑</el-button
            >
            <span class="operationLine">|</span>
            <el-button type="text" @click="baseDeleteById(scope.row.roleId)"
              >删除</el-button
            >
            <span class="operationLine">|</span>
            <el-button type="text" @click="addAuthorization(scope.row.roleId)"
              >授权</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="getDataListSizeChange"
        @current-change="getDataListCurrentChange"
        :current-page="queryData.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="dataForm.roleId ? '修改' : '新增'"
      :visible.sync="centerDialogVisible"
      width="800px"
      center
    >
      <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="100px"
        :rules="dataFormRules"
      >
        <el-form-item prop="roleName" label="角色名称">
          <el-input v-model.trim="dataForm.roleName"></el-input>
        </el-form-item>
        <el-form-item prop="indexUrl" label="入口页">
          <el-input v-model.trim="dataForm.indexUrl"></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input v-model.trim="dataForm.remark"></el-input>
        </el-form-item>
        <el-form-item prop="sort" label="排序">
          <el-input-number :min="1" placeholder="排序" v-model="dataForm.sort">
          </el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDataForm" :loading="loadingFlag"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 弹窗, 授权 -->
    <to-grant-authorization
      ref="toGrantAuthorization"
      @refreshDataList="getDataList()"
    ></to-grant-authorization>
  </div>
</template>
<script>
import toGrantAuthorization from "./role-to-grant-authorization";
export default {
  components: {
    toGrantAuthorization,
  },
  data() {
    return {
      tableData: [],
      queryData: {
        current: 1,
        size: 10,
        name: "",

        // like: [["String", "role_name", ""]],
        // orderBy: [["Number ", "sort", "true"]],
      },
      total: 0,
      centerDialogVisible: false,
      authorizationPop: false,
      dataForm: {},
      dataFormRules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
      },
      loadingFlag: false,
    };
  },
  created() {},
  mounted() {
    this.getDataList();
  },
  methods: {
    // 授权
    addAuthorization(id) {
      this.$nextTick(() => {
        this.$refs.toGrantAuthorization.init(id);
      });
    },
    // 新增
    addOrEditPopup(row) {
      this.centerDialogVisible = true;
      if (row) {
        this.dataForm = JSON.parse(JSON.stringify(row));
      } else {
        this.dataForm = {};
      }
    },

    /**
     * 删除数据
     */
    baseDeleteById(id) {
      if (id) {
        this.$confirm("是否删除所选择的数据?", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$http
              .delete(`/sys-role/baseDeleteById/${id}`)
              // .delete(`admin/sys-role/baseDeleteById/${id}`)
              .then((res) => {
                if (res.data.code == 200) {
                  this.getDataList();
                  this.$VueMessage({
                    type: "success",
                    message: "删除成功!",
                  });
                } else {
                  this.$VueMessage({
                    message: res.data.msg,
                    type: "warning",
                  });
                }
              });
          })
          .catch(() => {
            this.$VueMessage({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 查询
    getDataList(flag) {
      // let _that=this;
      // setInterval(function(){
      //   _that
      // },100)
      let data = this.queryData;
      if (flag) data.current = 1;
      this.loadingFlag = true;
      this.$http
        .get(`sys-role/getSelectPage`, {
          params: data,
        })
        // .post(`admin/sys-role/page`, this.$guolv(this.queryData))
        .then((res) => {
          this.loadingFlag = false;
          if (res.data.code == 200) {
            let data = res.data.data;
            let list = data.records;
            this.tableData = list;
            this.total = data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataListSizeChange(val) {
      this.queryData.size = val;
      this.getDataList(true);
    },
    getDataListCurrentChange(val) {
      this.queryData.current = val;
      this.getDataList();
    },
    /**
     * 上传图片成功
     */
    uploadSuccess(res) {
      this.$store.state.beforeUploadLoading.close();
      this.$set(this.dataForm, "icon", res.data);
    },
    submitDataForm() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.loadingFlag = true;
          let url = "sys-role/saveOrUpdate";
          // let url = "admin/sys-role/saveOrUpdate";
          let data = this.dataForm;
          this.$http.post(`${url}`, data).then((res) => {
            this.loadingFlag = false;
            if (res.data.code == 200) {
              this.$VueMessage({
                message: "操作成功",
                type: "success",
              });
              this.centerDialogVisible = false;
              this.getDataList();
              // this.$emit("refreshDataList");
            } else {
              this.$VueMessage({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="less">
</style>

